<template>
  <div class="beverage__slide">
       <h1 v-if="targetSlide || isSingle" class="category__title beverage__page__title">{{beverage.title}}</h1>
     <div v-for="(size, s) in beverage.sizes" class="beverage__image"
      :class="{'is-visible':activeSize===s}" :key="s"
    >
    <img v-if="size.alt_title" :src="mediaPath(size['size_image_'+$store.getters.lang])" class="thumb__image" :alt="size.alt_title + ' '  + size.size" :title="size.alt_title + ' ' + size.size" :style="{height:height + 'px'}" />
          
    <img v-else :src="mediaPath(size['size_image_'+ $store.getters.lang])" :alt="beverage.title + s" :title="beverage.title + s" :style="{height:height + 'px'}" />
    </div>
    <div class="beverage__card card" :style="{backgroundColor:beverage.color}">
      <span @click="goBack" class="card__back" />
      <div class="card__fields card__fields--left">
        <div v-if="beverage.subcategory && beverage.subcategory.length"
          class="card__category" v-text="beverage.subcategory"
        />
        <div v-else class="card__category" v-text="category.title" />
        <h2 v-text="beverage.title" />

        <div class="card__field card__field--description" v-if="beverage.description">
          <div class="card__value card__value--description" v-text="beverage.description"
          />
        </div>
        <div class="card__field" v-for="(field, l) in beverage.left_section"
          :key="l">
          <div v-if="field.label" class="card__label" v-text="field.label"
          />
          <div class="card__value" v-text="field.value" />
        </div>
      </div>
      <div class="card__fields card__fields--right">
        <div class="card__field" v-for="(field, l) in beverage.right_section"
          :key="l">
          <div v-if="field.label" class="card__label" v-text="field.label"
          />
          <div class="card__value" v-text="field.value" />
        </div>
        <div class="card__field card__field--sizes" v-if="beverage.sizes">
          <div class="card__label" v-text="$store.getters.ui.size_label"
          />
          <div class="card__size" v-for="(size, s) in beverage.sizes" :key="s"
            @click="setSize(s)" v-text="size['size']" :class="{'is-active':activeSize===s}"
          />

            <router-link v-if="item['show_'+lang]===1"  v-for="(item, i) in nav.items" :to="item.path" tag="li"
              :key="'item'+i">

              <a v-if="item.id === 2" class="cta__link">
               {{$store.state.ui.contact_label}} <i class="more__arrow more__category"></i>
              </a>
            </router-link>
        </div>
      </div>
    </div>
    <div :style="{ backgroundColor: category.color }" class="related__text__columns related__text--slider">
    <div class="related_thumbs related__text ">
      <div v-if="beverage.description_1 && beverage.description_1.length > 2">
  <p v-html="beverage.description_1" />
</div>
<div v-if="beverage.description_2 && beverage.description_2.length > 2">
  <p v-html="beverage.description_2" />
</div>
    </div>
    <router-link to="/" class="cta__link_back" :style="{backgroundColor:category.color}" >
                {{$store.state.ui.return_home}}
                <i class="more__arrow more__category"></i>
        </router-link>
  </div>  
      
  </div>
</template>

<script>
import ifDefined from '@/tools/ifDefined'
import { mapGetters } from 'vuex'

export default {
  props: ['category', 'beverage', 'swiper', 'i'],
  components: {},
  name: 'BeverageSlide',
  data() {
    return {
      activeSize: 0,
      isSingle: false,
      debouncedHeight: 0,
      heightTimeout: null
    }
  },
  computed: {
    ...mapGetters(['baseURL', 'nav', 'mobNav', 'device', 'navOpen', 'ui', 'lang']),
    height: {
      get() {
        return this.debouncedHeight
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout)
        this.heightTimeout = setTimeout(() => {
          this.debouncedHeight = val
        }, 0)
      }
    },
    targetSlide() {
      if (ifDefined(this.swiper)) {
        return this.swiper['activeIndex'] === this.i
      } else {
        return false
      }
    }
  },
  methods: {
    resizeHandler(e) {
      this.height = document.querySelector('.beverage__card').offsetHeight + 80 - 16
    },
    setSize(i) {
      var targetSize = 0
      if (i || i === 0) targetSize = i
      else {
        if (ifDefined(this.beverage.sizes)) {
          this.beverage.sizes.forEach((size, s) => {
            if (Number(size.show_default) === 1) {
              targetSize = s
            }
          })
        }
      }
      this.activeSize = targetSize
    },
    goBack() {
      this.$router.push('/' + this.category.slug)
    }
  },
  mounted() {
    this.setSize()
    if (document.querySelector('.beverage__slide.is-single')) {
      this.isSingle = true
    }
    this.height = document.querySelector('.beverage__card').offsetHeight + 80 - 16
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BeverageSlide.vue